import moment from 'moment';
import secureLocalStorage from "react-secure-storage";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export function getRequestParams(methodType, request) {
    let auth_header = "";
    let session_token = secureLocalStorage.getItem('session_token');
    if (session_token !== undefined && session_token !== null && session_token.length !== 0) {
        auth_header = 'Bearer ' + session_token;
    }

    if (methodType === "GET") {
        const requestParams = {
            method: methodType,
            headers: {
                'Content-Type': 'application/json',
                'CultureCode': secureLocalStorage.getItem('session_culturecode'),
                'Authorization': auth_header
            },
        }
        return requestParams;
    }
    else if (methodType === "DELETE") {
        const requestParams = {
            method: methodType,
            headers: {
                'Content-Type': 'application/json',
                'CultureCode': secureLocalStorage.getItem('session_culturecode'),
                'Authorization': auth_header
            },
        }
        return requestParams;
    }
    else if (methodType === "PUT" && request !== null) {
        const requestParams = {
            method: methodType,
            headers: {
                'Content-Type': 'application/json',
                'CultureCode': secureLocalStorage.getItem('session_culturecode'),
                'Authorization': auth_header
            },
            body: JSON.stringify(request)
        }
        return requestParams;
    }

    else if (methodType === "PUT" && request === null) {
        const requestParams = {
            method: methodType,
            headers: {
                'Content-Type': 'application/json',
                'CultureCode': secureLocalStorage.getItem('session_culturecode'),
                'Authorization': auth_header
            },
        }
        return requestParams;
    }
    else {
        const requestParams = {
            method: methodType,
            headers: {
                'Content-Type': 'application/json',
                'CultureCode': secureLocalStorage.getItem('session_culturecode'),
                'Authorization': auth_header
            },
            body: JSON.stringify(request)
        }
        return requestParams;
    }
}

export function formatDate(date, dateformat) {
    if (dateformat === "MM/dd/yyyy") {
        return moment(date).format("MM/DD/YYYY");
    }
    if (dateformat === "dd/MM/yyyy") {
        return moment(date).format("DD/MM/YYYY");
    }
    if (dateformat === "MMM/dd/yyyy") {
        return moment(date).format("MMM") + "-" + moment(date).format("D") + "-" + moment(date).format("YYYY");
    }
    if (dateformat === "dd/MMM/yyyy") {
        return moment(date).format("D") + "-" + moment(date).format("MMM") + "-" + moment(date).format("YYYY");
    }
    if (dateformat === "yyyy-MM-dd") {
        return moment(date).format("YYYY-MM-DD");
    }
    if (dateformat === "yyyy/MM/dd") {
        return moment(date).format("YYYY/MM/DD");
    }
    if (dateformat === "MM/dd/yyyy hh:mm") {
        return moment(date).format("MM/DD/YYYY HH:mm");
    }
    if (dateformat === "MM/dd/yyyy hh:mm:ss") {
        return moment(date).format("MM/DD/YYYY HH:mm:ss");
    }
    if (dateformat === "dd/MM/yyyy hh:mm") {
        return moment(date).format("DD/MM/YYYY HH:mm");
    }
    if (dateformat === "dd/MM/yyyy hh:mm:ss") {
        return moment(date).format("DD/MM/YYYY HH:mm:ss");
    }
    if (dateformat === "yyyy-MM-dd HH:mm:ss") {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
    }
    if (dateformat === "yyyyMMddHHmmss") {
        return moment(date).format("YYYYMMDDHHmmss");
    }
    if (dateformat === "yyyyMMdd" || dateformat === "yyyymmdd") {
        return moment(date).format("YYYYMMDD");
    }
    if (dateformat === "MMM") {
        return moment(date).format("MMM");
    }
    if (dateformat === "D") {
        return moment(date).format("D");
    }
    if (dateformat === "HH:mm:ss") {
        return moment(date).format("HH:mm:ss");
    }
    return moment(date).format("MM/DD/YYYY HH:mm:ss");
}

export function formatTime(date, timeformat) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    var hour = '' + d.getHours();
    var minutes = '' + d.getMinutes();
    var seconds = '' + d.getSeconds();

    if (timeformat === "hh:mm") {
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        if (hour <= 9) {
            hour = '0' + hour;
        }

        if (minutes <= 9) {
            minutes = '0' + minutes;
        }

        return [hour, minutes].join(':');
    }

    if (timeformat === "hh:mm:ss") {
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        if (hour <= 9) {
            hour = '0' + hour;
        }

        if (minutes <= 9) {
            minutes = '0' + minutes;
        }

        if (seconds <= 9) {
            seconds = '0' + seconds;
        }

        return [hour, minutes, seconds].join(':');
    }

    return [hour, minutes, seconds].join(':');
}

export function timeDiffCalc(futureDate, currentDate, format) {
    let diffInSeconds = Math.abs(new Date(futureDate) - new Date(currentDate)) / 1000;

    // calculate days
    const days = Math.floor(diffInSeconds / 86400);
    diffInSeconds -= days * 86400;

    // calculate hours
    const hours = Math.floor(diffInSeconds / 3600) % 24;
    diffInSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInSeconds / 60) % 60;
    diffInSeconds -= minutes * 60;

    const seconds = Math.floor(diffInSeconds);

    let difference = '';
    
    if (format === "DHM") {
        if (days > 0) {
            difference += (days <= 1) ? `${days} day, ` : `${days} days, `;
        }
        difference += (hours <= 1) ? `${hours} hrs, ` : `${hours} hrs, `;
        difference += (minutes <= 1) ? `${minutes} mins` : `${minutes} mins`;
    }
    else if (format === "HM") {
        let _hours = hours;
        if (days > 0) {
            _hours = _hours + (days * 24);
        }
        if (_hours >= 1) {
            difference += (_hours <= 1) ? `${_hours} hr ` : `${_hours} hrs `;
            difference += (minutes <= 1) ? `${minutes} min` : `${minutes} mins`;
        } else {
            difference += (minutes <= 1) ? `${minutes} min ` : `${minutes} mins `;
            difference += (seconds <= 1) ? `${seconds} sec` : `${seconds} secs`;
        }
    }
    else if (format === "D") {
        difference += (days <= 1) ? `${days} day, ` : `${days} days, `;
    }
    else if (format === "H") {
        difference += (hours <= 1) ? `${hours} hrs, ` : `${hours} hrs, `;
    }
    else if (format === "M") {        
        difference += (minutes <= 1) ? `${minutes} mins` : `${minutes} mins`;
    }
    else {
        difference += (hours <= 1) ? `${hours} hrs, ` : `${hours} hrs, `;
        difference += (minutes <= 1) ? `${minutes} mins` : `${minutes} mins`;
    }

    return difference;
}

export function HasValue(str) {
    return !!str && /^\s*$/.test(str) === false;
}

export function getCurrentDateTime() {
    return secureLocalStorage.getItem("session_locationTime") == null || secureLocalStorage.getItem("session_locationTime") == "";
}

export function getVehicleLabelByIndustry(text) {
    if (text != null && text.length > 0 && secureLocalStorage.getItem("session_industryTypeId") == "4") {
        return text.replace("Vehicle", "Ambulance");
    }
    return text;
}

export function isNullOrEmpty(value) {
    return value === undefined || value === null || value === '';
}

export function getIconColorByVehicleStatus(status) {
    var color = 'gray';
    switch (status) {
        case 'Moving':   //statusId = 1
            color = 'green';
            break;
        case 'Stopped':   //2
            color = 'red';
            break;
        case 'Idle':   // 3
            color = 'orange';
            break;
        case 'Out Of Service':
            color = 'blue';
            break;
        default:
            color = color;
            break;
    }
    return color;

}

export function getIconColorByTripStatus(status) {
    var color = 'gray';
    switch (status) {
        case "START":
            color = '#00a65a';
            break;
        case "START TRIP":
            color = '#00a65a';
            break;
        case "ON ROAD":
            color = '#ffee1a';
            break;
        case "OFF ROAD":
            color = '#333333';
            break;
        case "ON SCENE":
            color = '#17ffff';
            break;
        case "ON BOARD":
            color = '#ff8a15';
            break;
        case "HOSPITAL IN":
            color = '#1a26ff';
            break;
        case "HOSPITAL OUT":
            color = '#a203ff';
            break;
        case "CLEAR":
            color = '#dd4b39';
            break;
        default:
            color = color;
    }
    return color;

}

export function getIconColorByGPSSignalStatus(status) {
    var color = 'gray';
    if (status == 1) {
        color = 'green';
    }
    return color;
}

export function getIconColorByOnlineStatus(status) {
    var color = 'gray';
    if (status == 1) {
        color = 'green';
    }
    return color;
}

export function parseBoolean(value) {
    return value === true || (value + '').toLowerCase() === 'true';
}

export function isMobileDevice() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export function getLocalizedString(sourceText, suffixText) {
    let localizedText = sourceText;
    try {
        var list = window.localizedStrings;
        if (list === null || list === undefined) {
            let localizedStr = localStorage.getItem("localizedStrings");
            if (localizedStr !== null && localizedStr.length > 0) {
                list = JSON.parse(localizedStr);
                window.localizedStrings = list;
            }
        }
        if (list !== null && list !== undefined) {
            var localizedItem = list.filter((item) => item.sourceText === sourceText)[0];
            if (localizedItem !== null && localizedItem !== undefined) {
                localizedText = localizedItem.localizedText;
            }
        }
    }  catch(e) {}
    return localizedText + suffixText;
}

export function subString2(val, length) {
    if (val === undefined || val === null || val.length <= length) {
        return val;
    }
    return val.substr(0, length);
}

export function getBaseApiUrl(apiUrl) {
    if (window.location.hostname.indexOf("localhost") === -1) {
        if (apiUrl.indexOf("track.utwiz.com") !== -1) {
            return apiUrl.replace("track.utwiz.com", window.location.hostname);
        } else if (apiUrl.indexOf("zhl.utwiz.com") !== -1) {
            return apiUrl.replace("zhl.utwiz.com", window.location.hostname);
        }
    }
    return apiUrl;
}

export function convertMsToTime(milliseconds){
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    // 👇️ If you don't want to roll hours over, e.g. 24 to 00
    // 👇️ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
    hours = hours % 24;

    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
}

export function padTo2Digits(num){
    return num.toString().padStart(2, '0');
}

export const getActivityXlsx = async (rowData) => {
  let userId = secureLocalStorage.getItem('session_userId');
  let accountId = secureLocalStorage.getItem('session_accountId');
  let locationId = secureLocalStorage.getItem('session_locationId');

  const request = {
    UserId: userId,
    AccountId: accountId,
    LocationId: locationId,
    GridName: "Activity",
    IndustryId: 4,
    IsFixed: false,
    VehicleId: [rowData.vehicleId],
    VehicleGroupId: 0,
    ReportType: 1,
    ReportTypeId: [],
    DateFrom: moment(rowData.startDateTemp).format("MM/DD/YYYY HH:mm:ss"),
    DateTo: rowData?.startDatetimeGps ? moment(rowData.endDateTemp).format("MM/DD/YYYY HH:mm:ss") : moment(rowData.scheduleDatetime).add(6, 'hours').format("MM/DD/YYYY HH:mm:ss"),
    MinimumKilometer: 0,
    MinimumStoppageDuration: 3,
    PoiId: [],
    ProjectId: 0,
    DistrictId: 0,
    PlantLocationId: 0,
    TripId: 0,
    JobNo: "",
    SubReport: ""
  };
  let requestParams = getRequestParams('POST', request);
  try {
    // this.setState({ loadPanelVisible: true });
    const response = await fetch(
      getBaseApiUrl(process.env.REACT_APP_REPORT_API_BASE_URL) + "Tracking/Activity",requestParams );
    //   this.setState({ loadPanelVisible: false });
    const result = await response.json();
    const data = result?.payload?.dataValues || [];
    if (data.length === 0) {
        alert("No data available to download.");
        return;
    }
    // Define Excel headers
    const columns = [
      { header: "Fleet location", key: "baseLocation" },
      { header: "Vehicle #", key: "vehicleNo" },
      { header: "Date", key: "dateTime" },
      { header: "Status", key: "status" },
      { header: "Speed", key: "speed" },
      { header: "Odometer", key: "odometer" },
      { header: "Place", key: "address" },
      { header: "Battery%", key: "batteryPercentage" },
      { header: "Ignition", key: "ignition" }
    ];

    // Create Excel workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Activity Report");

    worksheet.columns = columns;

    // Fill rows
    data.forEach((item) => {
      worksheet.addRow({
        baseLocation: item.baseLocation || "",
        transporter: item.transporter || "",
        vehicleNo: item.vehicleNo,
        dateTime: item.dateTime,
        status: item.status,
        speed : item?.speed ? item?.speed : 0,
        odometer: item.odometer,
        address: item.address,
        batteryPercentage: item.batteryPercentage,
        ignition: item.ignition

      });
    });

    worksheet.getColumn("baseLocation").width = 20;
    worksheet.getColumn("vehicleNo").width = 20;
    worksheet.getColumn("dateTime").width = 20;
    worksheet.getColumn("speed").width = 10;
    worksheet.getColumn("odometer").width = 20;
    worksheet.getColumn("address").width = 20;

    // Export to XLSX
    const buffer = await workbook.xlsx.writeBuffer();
    const fileName = `Activity_Report_${moment().format("YYYY-MM-DD_HH-mm")}.xlsx`;
    saveAs(new Blob([buffer]), fileName);
  } catch (error) {
    console.error("Error downloading report:", error);
    alert("Something went wrong while downloading the report.");
  }
};